import { BaseApi } from './base.api.js';

export class VendorApi extends BaseApi {
    constructor(client) {
        super(client, '/vendor');
    }
}
